import { applyDashboardsSwitch } from './dashboardsSwitch';

export interface Config {
  dashboards: any;
  endpoints: any;
  bepActiveFlag: boolean;
  fepSpotActiveFlag: boolean;
  fepForwardsActiveFlag: boolean;
  fepNonLinearActiveFlag: boolean;
  repLinearActiveFlag: boolean;
  uploadValidationPollInterval: number;
  thoughtSpotHost: string;
  // Jitto Answer embed (ANS-545). Dashboards: config/jittoDashboards.json.
  jittoEmbedActiveFlag?: boolean;
  jittoEmbedOrigin?: string;
  // The embed SDK applies host filters (ANS-801): the currency picker shows with Jitto on.
  jittoHostFilters?: boolean;
  // ?dashboards=thoughtspot|jitto picks this tab's dashboards (config/dashboardsSwitch.js).
  dashboardsSwitch?: boolean;
  // The ThoughtSpot pick's dashboards, when they differ from the Jitto routes.
  thoughtSpotDashboards?: any;
  // Asset classes only Jitto has; the ThoughtSpot pick drops them.
  jittoOnlyAssetClasses?: string[];
}

export const env = process.env.REACT_APP_TPICAP_ENV
  ? process.env.REACT_APP_TPICAP_ENV
  : 'development';
const tab = typeof window !== 'undefined' ? window : undefined;
let storage: Storage | undefined;
try {
  storage = tab ? tab.sessionStorage : undefined;
} catch (ignored) {
  storage = undefined;
}
const config = applyDashboardsSwitch(
  require(`./${env}`).default,
  tab ? tab.location.search : '',
  storage,
) as Config;
export default config;
